import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { IXeroAccountDataResolveData } from './xero-data.data';
import { Observable, of } from 'rxjs';
import { XeroAccount } from './xero-account.model';
import { XeroDataStore } from './xero-data.store';
import { FeaturesDataStore } from '../features-data/features-data.store';
import { Toggles } from '../features-data/sub-models/toggles.model';
import { flatMap, map, take } from 'rxjs/operators';

@Injectable()
export class XeroDataResolve implements Resolve<IXeroAccountDataResolveData> {
  static RESOLVE = {
    xeroData: XeroDataResolve,
  };

  constructor(
    private _xeroDataStore: XeroDataStore,
    private _featuresDataStore: FeaturesDataStore
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<IXeroAccountDataResolveData> {
    return this._featuresDataStore.getFeatureToggles().pipe(
      flatMap((featureToggles: Toggles) => {
        if (!featureToggles.isForbidden(Toggles.KEYS.XERO)) {
          return this._xeroDataStore
            .getXeroAccount()
            .pipe(map((xeroAccount: XeroAccount) => ({ xeroAccount })));
        } else {
          return of(null);
        }
      }),
      take(1)
    );
  }
}
